import type { Conversation } from "./types";

export const UNASSIGNED_CUSTOMER_SCOPE = "__unassigned__";
export const ALL_CUSTOMERS_SCOPE = "__all__";

export type ConversationCustomerOption = {
  id: string;
  label: string;
  count: number;
};

export function conversationCustomerOptions(conversations: Conversation[]) {
  const options = new Map<string, ConversationCustomerOption>();
  let unassigned = 0;
  for (const conversation of conversations) {
    if (!conversation.customerId) {
      unassigned += 1;
      continue;
    }
    const current = options.get(conversation.customerId);
    options.set(conversation.customerId, {
      id: conversation.customerId,
      label: conversation.customer || "Cliente sin nombre",
      count: (current?.count ?? 0) + 1,
    });
  }
  const sorted = [...options.values()].sort((a, b) => a.label.localeCompare(b.label, "es"));
  if (unassigned) sorted.push({ id: UNASSIGNED_CUSTOMER_SCOPE, label: "Sin cliente asignado", count: unassigned });
  return sorted;
}

export function conversationMatchesCustomer(conversation: Conversation, customerScope: string) {
  if (!customerScope || customerScope === ALL_CUSTOMERS_SCOPE) return true;
  if (customerScope === UNASSIGNED_CUSTOMER_SCOPE) return !conversation.customerId;
  return conversation.customerId === customerScope;
}
